import "./Footer.css"

export default function Footer(){
    return (
    <>

        <div className="footerdiv">

        </div>

    </>
    )
}